import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import './DefaultValueEditor.scss';

const DefaultValueEditor = ({ property, readOnly, value, indentIfNA, onChange, children }) => {
  const { conditionalEditing = undefined } = property;
  const handleChange = (event) => {
    const newEvent = Object.assign({}, event);
    newEvent.target = Object.assign({}, event.target);
    newEvent.target.value = event.target.checked
      ? conditionalEditing.defaultEditingValue : conditionalEditing.noneEditingValue;
      onChange(newEvent);
  };
  if (conditionalEditing === undefined) {
    if (indentIfNA) {
      return (
        <div
          className="tuc-default-value-editor"
        >
          <Checkbox
            checked={false}
            onChange={handleChange}
            disabled={readOnly}
            value={property.name}
            className="tuc-default-value-checkbox tuc-default-value-hide"
          />
          <div className="tuc-default-value-editor-content">
            {children}
          </div>
        </div>
      );
    }
    return children;
  }
  const editing = value !== conditionalEditing.noneEditingValue;
  return (
    <div className="tuc-default-value-editor">
      <FormControl margin="normal">
        <Checkbox
          checked={editing}
          onChange={handleChange}
          disabled={readOnly}
          value={property.name}
          className="tuc-default-value-checkbox"
          color="default"
        />
      </FormControl>
      <div className="tuc-default-value-editor-content">
        {!editing ? (
          <FormControl margin="normal">
            <div className="tuc-default-value-editor-label-ctnr">
              <InputLabel shrink>{property.label}</InputLabel>
              {property.description && (
                <FormHelperText>{property.description}</FormHelperText>
              )}
            </div>
          </FormControl>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

DefaultValueEditor.propTypes = {
  property: PropTypes.shape({
    conditionalEditing: PropTypes.shape({}),
    name: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({}),
    ])),
  ]),
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  indentIfNA: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

DefaultValueEditor.defaultProps = {
  value: undefined,
  readOnly: false,
  indentIfNA: false,
};

export default DefaultValueEditor;
